module.exports = {
    namespace: "radio",
    checked: '',
    unchecked:''
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/RadioItemTemplate-style.js
 **/